module.exports = __webpack_public_path__ + "img/default-google-maps-honda.248c6e8e.png";